import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { editCustomFormFields } from "../../../Utils/AllPagesQuriesAndMutations";
import "../FormComponents/FormComponent.scss";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../ToastComponent/RectHotToast";
import CustomFormModal from "./CustomFormModal";
import "./FormConfiguration.scss";
import { InputFieldPreferences } from "./InputFieldPreferences/InputFieldPreferences";
import DefaultFormFieldsModal from "./DefaultFormFieldsModal";
import { useModalContext } from "../Reactportal/ModalContext";

export const FormConfiguration = ({
  show,
  ParentClosingFunction,
  formRef,
  config,
  HanldeChangeonForm,
  setFirstLoad,
  allFieldsData,
  getFormSectionAndFields,
  formKey,
  forFormValues,
  ToGetDefaultValues,
  preference,
}) => {
  console.log(ToGetDefaultValues, "ToGetDefaultValues");
  const [prefShow, setPrefShow] = useState(false);
  const [cusFieldsModal, setCusFieldsModal] = useState(false);
  const [defaultFieldsModal, setDefaultFieldsModal] = useState(false);
  const [toggle, setToggle] = useState(show ? show : false);
  const [isRefetch, setIsRefetch] = useState(false);
  const [updatedRows, setUpdatedRows] = useState([]);
  const { pushModal, popModal } = useModalContext();
  const Model_Key = "Configaration_Modal";
  const Custom_Fields = "Custom_Fields_Model";
  const Default_Fields = "Default_Fields";

  let prevData = formRef.current?.FormConfiguration?.values || allFieldsData;

  const CloseFormFunctionForConfigForm = () => {
    console.log("Function is Triggerd");
    popModal(Model_Key);
    setToggle(false);
    ParentClosingFunction();
  };

  const CloseCustomFormModal = () => {
    setCusFieldsModal(false);
    ParentClosingFunction();
    popModal(Custom_Fields);
    popModal(Model_Key);
  };

  const closeDefaultFormModal = () => {
    setDefaultFieldsModal(false);
    ParentClosingFunction();
    popModal(Default_Fields);
    popModal(Model_Key);
  };

  const [EditingData] = useMutation(editCustomFormFields);

  const submit = async (action) => {
    console.log(action, "modalStackmodalStackmodalStackmodalStack");
    if (updatedRows?.length > 0) {
      try {
        await EditingData({
          variables: { updateCustomFieldsData: updatedRows },
        }).then(async () => {
          SuccessToast("fields updated successfully.");
          ToGetDefaultValues();
          if (action === "Close") {
            await getFormSectionAndFields();
            CloseCustomFormModal();
            closeDefaultFormModal();
          } else {
            setIsRefetch(true);
            setUpdatedRows([]);
          }
        });
      } catch (error) {
        ErrorToast("An error occurred while updating custom fields. Please try again.");
        console.error("Mutation failed:", error);
      }
    } else if (action === "Close") {
      CloseCustomFormModal();
      closeDefaultFormModal();
      setUpdatedRows([]);
    }
  };

  const saveFunction = () => {
    submit("Close");
  };

  const saveAndCloseFunction = () => {
    submit("Close");
  };
  useEffect(() => {
    pushModal(Model_Key);
  }, []);

  const footerContent = (
    <PortalFooter
      handleformclose={() => {
        CloseFormFunctionForConfigForm();
      }}
      Form_key={Model_Key}
    />
  );
  return (
    <div>
      <Reactportal
        open={toggle}
        onClose={CloseFormFunctionForConfigForm}
        TypeOfPortal={"Configure"}
        FoooterContent={footerContent}
      >
        <>
          {/* // {pinCodeLoading && <div className="loader-line-div" />} */}
          <div className="ConfigurationContainer">
            {preference && (
              <div
                onClick={() => {
                  setPrefShow(true);
                }}
              >
                Preferences
              </div>
            )}

            <div
              onClick={() => {
                setCusFieldsModal(true);
                pushModal(Custom_Fields);
              }}
            >
              Custom Fields
            </div>

            <div
              onClick={() => {
                setDefaultFieldsModal(true);
                pushModal(Default_Fields);
              }}
            >
              Default Fields
            </div>

            {prefShow && (
              <InputFieldPreferences
                formKey={formKey}
                prefConfig={config}
                show={prefShow}
                setPrefShow={setPrefShow}
                formRef={formRef}
                prevData={prevData}
                setFirstLoad={setFirstLoad}
                HanldeChangeonForm={HanldeChangeonForm}
                allFieldsData={allFieldsData}
                CloseFormFunctionForConfigForm={CloseFormFunctionForConfigForm}
                forFormValues={forFormValues}
                ToGetDefaultValues={ToGetDefaultValues}
              />
            )}
          </div>
        </>
      </Reactportal>
      {cusFieldsModal && (
        <div>
          <Reactportal open={cusFieldsModal} onClose={CloseCustomFormModal}>
            <CustomFormModal
              formKey={formKey}
              getFormSectionAndFields={getFormSectionAndFields}
              IsRefetch={isRefetch}
              setIsRefetch={setIsRefetch}
              setUpdatedRows={setUpdatedRows}
              ToGetDefaultValues={ToGetDefaultValues}
            />

            <PortalFooter
              renderContent={() => <></>}
              disabled={false}
              submitType={"Save"}
              Form_key={Custom_Fields}
              submitform={() => {
                saveFunction();
              }}
              SaveAndClose={() => {
                saveAndCloseFunction();
              }}
              handleformclose={() => {
                CloseCustomFormModal();
              }}
            />
          </Reactportal>
        </div>
      )}
      {defaultFieldsModal && (
        <div>
          <Reactportal open={defaultFieldsModal} onClose={closeDefaultFormModal}>
            <DefaultFormFieldsModal
              formKey={formKey}
              getFormSectionAndFields={getFormSectionAndFields}
              IsRefetch={isRefetch}
              setIsRefetch={setIsRefetch}
              setUpdatedRows={setUpdatedRows}
              ToGetDefaultValues={ToGetDefaultValues}
            />

            <PortalFooter
              renderContent={() => <></>}
              disabled={false}
              submitType={"Save"}
              Form_key={Default_Fields}
              submitform={() => {
                saveFunction();
              }}
              SaveAndClose={() => {
                saveAndCloseFunction();
              }}
              handleformclose={() => {
                closeDefaultFormModal();
              }}
            />
          </Reactportal>
        </div>
      )}
    </div>
  );
};
